module.exports = __webpack_public_path__ + "static/media/sorting-icon.c73660d7.svg";